import { en } from './en.js'

export const pt = structuredClone(en)
